/**
 * Tab-focus helper.
 *
 * Shared by the chat/support surfaces to answer "is the user actively looking
 * at this app tab right now?". Used to:
 *   - suppress a chat toast for a conversation the user is already reading
 *     (`useChatRealtime`), and
 *   - gate mark-read so a backgrounded tab's background poll doesn't silently
 *     advance read-state (`ChatConversation`, `TicketDetail`).
 *
 * In a non-DOM environment (SSR / older test envs) we default to `true` so the
 * feature degrades to "always active" rather than throwing.
 */
export function isTabFocused(): boolean {
  if (typeof document === "undefined") return true;
  return document.hasFocus() && document.visibilityState === "visible";
}
